/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import dynamic from 'next/dynamic';
import { ReactNode, FunctionComponent } from 'react';
import styled from 'styled-components';
import { mediaBreakpointMixin } from '@zillow/constellation';

const ContentContainer = styled.div`
    position: relative;
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;
    min-height: 100vh;
    @media ${mediaBreakpointMixin('md_lte')} {
        min-height: 150vh;
    }
    @media ${mediaBreakpointMixin('sm_lte')} {
        min-height: 250vh;
    }
`;

const ZHLPage = styled.div`
    position: relative;
`;

const ZHLHeader = dynamic(async () => {
    const { ZHLHeader: Component } = await import(
        /* webpackChunkName: "ZHLHeader" */
        './components/ZHLHeader'
    );
    return Component;
});
const ConditionalZHLABAD = dynamic(async () => {
    const { ConditionalZHLABAD: Component } = await import(
        /* webpackChunkName: "ConditionalZHLABAD" */
        './components/ConditionalZHLABAD'
    );
    return Component;
});

const ConditionalZHLFooter = dynamic(async () => {
    const { ConditionalZHLFooter: Component } = await import(
        /* webpackChunkName: "ConditionalZHLFooter" */
        './components/ConditionalZHLFooter'
    );
    return Component;
});

export type ZHLConditionalPageWrapperProps = {
    /**
     * Whether the content is rendered on a Zillow Origin or not
     */
    isZillowOrigin: boolean;
    /**
     * The page content
     */
    children: ReactNode;
};

/**
 * Conditionally renders the ZHL Page Wrapper around content, based on whether the content is indicated
 * to be on a Zillow Origin.
 *
 * Renders the children unchanged on Zillow Origins, since the `_document.tsx` provides the page frame
 * wrapping in those instances.
 */
export const ZHLConditionalPageWrapper: FunctionComponent<ZHLConditionalPageWrapperProps> = ({
    isZillowOrigin,
    children,
}) => {
    if (isZillowOrigin) {
        return children;
    }
    return (
        <ZHLPage>
            <ZHLHeader />
            <ContentContainer>{children}</ContentContainer>
            <ConditionalZHLABAD />
            <ConditionalZHLFooter />
        </ZHLPage>
    );
};
